import { Group, Stack, Switch } from "@mantine/core"
import { getCoreRowModel, useReactTable } from "@tanstack/react-table"
import { ExportButton, ExportType } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { Table } from "~/components/table/Table"
import { useGetAgecExportColumns } from "~/pages/Admin/Exports/AgecStats/export-columns"
import { useExportAGECStatsMutation } from "~/pages/Admin/Exports/AgecStats/hooks/useExportAGECStatsMutation"

type Props = {
  agecStats: AdminResponses.FindAllAgecStatsResponseDto
  groupByCollection: boolean
  setGroupByCollection: Dispatch<SetStateAction<boolean>>
}

export const AgecStatsTable = ({
  agecStats,
  groupByCollection,
  setGroupByCollection,
}: Props) => {
  const columns = useGetAgecExportColumns()
  const { mutate: csvDownload, isLoading: isAgecStatsExportLoading } =
    useExportAGECStatsMutation({ groupByCollection })
  const { t } = useTranslation(["products", "common"])

  const table = useReactTable({
    data: agecStats.agecStats,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <Stack>
      <Group justify="space-between">
        <Group>
          <Switch
            label="Stats by collection"
            checked={groupByCollection}
            onChange={() => setGroupByCollection(!groupByCollection)}
          />
        </Group>
        <Group>
          <ExportButton
            label={t("lists.export.all")}
            exportOptions={[
              {
                type: ExportType.CSV,
                label: t("common:actionButtons.exportAsCsv"),
                exportFunction: csvDownload,
                isLoading: isAgecStatsExportLoading,
              },
            ]}
          />
        </Group>
      </Group>
      <Table pagination={false} table={table} />
    </Stack>
  )
}
